var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFertility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2692 13.7735H12.8832C13.2106 13.7735 13.476 13.5121 13.476 13.1896C13.476 11.3419 13.0284 9.52174 11.1679 8.74135C10.2139 7.27228 9.80172 6.01565 8.07544 6.01562C4.95947 6.01562 4.59831 9.88816 4.52468 12.4754C4.50445 13.1866 5.09317 13.7735 5.81537 13.7735H6.42106L6.7967 15.5215C6.9516 16.2421 7.59735 16.7578 8.34512 16.7578C9.09289 16.7578 9.73864 16.2421 9.89354 15.5215L10.2692 13.7735Z",
    stroke: "#000000",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17938 6.01647C9.70715 6.01647 10.5665 5.1571 10.5665 3.62933C10.5665 2.10156 9.70715 1.24219 8.17938 1.24219C6.65161 1.24219 5.79224 2.10156 5.79224 3.62933C5.79224 5.1571 6.65161 6.01647 8.17938 6.01647Z",
    stroke: "#000000",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFertility);
export default __webpack_public_path__ + "static/media/fertility.8497d6d911a2b73f2fe493821b8ad806.svg";
export { ForwardRef as ReactComponent };